module.exports = __webpack_public_path__ + "img/beijingtu.177b8be3.png";